
import React from 'react';



function UserApproveRow({ type, label, value, id, PDFView, onChange, onClick, inputRef }) {
  
  return (
    <div className="row mt-2">
      
      {value && <div className="col-md-12"><button type="button" className="button2" onClick={onClick}>View selected Application</button></div> }
      <div className="col-md-12"> <label htmlFor={id}>Select the application file:</label> <input type={type} className="form-control" id={id} name={id}  onChange={onChange} ref={inputRef} required /></div>
     


    </div>
  );
}

export default UserApproveRow;